import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import EPage from '@/enums/EPages';
import { PrivateRoute } from '@/hooks/useAuth';
import EBasicActions from '@/enums/EBasicActions';

const MetaFormsPage = lazy(() => import('@/containers/Views/MetaForms/MetaFormsPage'));

const MetaFormsRouter = (
  <Route path="meta_forms">
    <Route
      index 
      element={(
        <PrivateRoute 
          pageName={EPage.MetaForms} 
          permissions={EBasicActions.Find}
        >
          <MetaFormsPage />
        </PrivateRoute>
      )} 
    />
  </Route>
);

export default MetaFormsRouter;
